import { navigate } from '@reach/router';

import React, { Component } from 'react';
import Webcam from 'react-webcam';

import Button from '../../../../components/Button';
import { IAvatarActions } from '../../../../store/avatar/actions';

interface IProps {
  actions: {
    avatar: IAvatarActions;
  };
}

class TakePicture extends Component<IProps, {}> {
  public refCam: any;
  constructor(props: IProps) {
    super(props);

    this.capture = this.capture.bind(this);
    this.refCam = React.createRef();
  }

  public capture(): void {
    const image = this.refCam.current.getScreenshot();
    this.props.actions.avatar.setBase64(image);
    navigate('/profile/edit-picture');
  }

  public handleZoom(_: any, zoom: number): void {
    this.setState({ zoom });
  }

  public render(): JSX.Element {
    const videoConstraints = {
      facingMode: 'user',
      height: 720,
      width: 1280
    };

    return (
      <div className="home account-settings wrapper take-picture">
        <div>
          <h2 className="account-title">TAKE A SELFIE</h2>
          <Webcam
            audio={false}
            height="auto"
            ref={this.refCam}
            screenshotFormat="image/jpeg"
            width="100%"
            {...{ videoConstraints }}
          />

          <Button
            id="take-pic"
            onClick={this.capture}
            variant="contained"
            color="primary"
            fullWidth={true}
            className="button button-shadow"
          >
            TAKE PICTURE
          </Button>
        </div>
      </div>
    );
  }
}

export { TakePicture };
